var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38672 9.5C2.09172 5.66 5.45622 2.75 9.50022 2.75C13.5442 2.75 16.9087 5.66 17.6145 9.5C16.9095 13.34 13.5442 16.25 9.50022 16.25C5.45622 16.25 2.09172 13.34 1.38672 9.5ZM9.50022 13.25C10.4948 13.25 11.4486 12.8549 12.1519 12.1517C12.8551 11.4484 13.2502 10.4946 13.2502 9.5C13.2502 8.50544 12.8551 7.55161 12.1519 6.84835C11.4486 6.14509 10.4948 5.75 9.50022 5.75C8.50566 5.75 7.55183 6.14509 6.84857 6.84835C6.14531 7.55161 5.75022 8.50544 5.75022 9.5C5.75022 10.4946 6.14531 11.4484 6.84857 12.1517C7.55183 12.8549 8.50566 13.25 9.50022 13.25ZM9.50022 11.75C8.90348 11.75 8.33118 11.5129 7.90923 11.091C7.48727 10.669 7.25022 10.0967 7.25022 9.5C7.25022 8.90326 7.48727 8.33097 7.90923 7.90901C8.33118 7.48705 8.90348 7.25 9.50022 7.25C10.097 7.25 10.6693 7.48705 11.0912 7.90901C11.5132 8.33097 11.7502 8.90326 11.7502 9.5C11.7502 10.0967 11.5132 10.669 11.0912 11.091C10.6693 11.5129 10.097 11.75 9.50022 11.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.d8d4091444c1eeee084f6e0c80333d0e.svg";
export { ForwardRef as ReactComponent };